/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import { GET_DELIVERY_ORDER } from "../../../utils/Endpoints";
import {GetRequest, GetResultObject} from "../../../utils/API";

const TYPES = {
  REQUEST_DELIVERY_ORDER: "REQUEST_DELIVERY_ORDER",
  REQUEST_DELIVERY_ORDER_SUCCESS: "REQUEST_DELIVERY_ORDER_SUCCESS",
  REQUEST_DELIVERY_ORDER_FAILED: "REQUEST_DELIVERY_ORDER_FAILED",

  UPDATE_ORDER_LIST: "UPDATE_ORDER_LIST",
};
const getDeliveryOrder = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_DELIVERY_ORDER,
      payload: {},
    });

    try {
      GetRequest(GET_DELIVERY_ORDER, params).then((result) => {
          GetResultObject(result, 'data.content', 200, (datas, {pages, size, total}) => {
            dispatch({
              type: TYPES.REQUEST_DELIVERY_ORDER_SUCCESS,
              payload: {data: datas, pages, size, total, currentPage: params.page},
            });
          })
        })
        .catch((error) => {
          dispatch({
            type: TYPES.REQUEST_DELIVERY_ORDER_FAILED,
            payload: { error },
          });
        });
      // return response;
    } catch (error) {
      dispatch({
        type: TYPES.REQUEST_DELIVERY_ORDER_FAILED,
        payload: { error },
      });
    }
  };
};


export default {
  getDeliveryOrder,
  TYPES,
};
